// extracted by mini-css-extract-plugin
export default {"label":"AuthorizationSection_label__mN3ZN","title":"AuthorizationSection_title__iAxJt"};